import React from "react";

import Polyline from "./shared/polyline";

const RoutePath = (props) => {
  const handleClick = (e) => {
    if (props.pathClick) {
      props.pathClick(e);
    }
  };

  const isActive = props.isActive === undefined || props.isActive === true;

  // Callers may override the isActive defaults, e.g. to dim unfocused routes.
  const makeOpaque = props.strokeOpacity ?? (isActive ? 1 : 0.5);

  const zIndex = props.zIndex ?? (isActive ? 10 : 5);

  return (
    <>
      {props.path ? (
        <Polyline
          onClick={handleClick}
          onMouseOver={props.onMouseOver}
          onMouseOut={props.onMouseOut}
          {...(props.clickable === undefined
            ? {}
            : { clickable: props.clickable })}
          strokeWeight={props.strokeWeight ?? 5}
          strokeColor={props.color}
          encodedPath={props.path}
          strokeOpacity={makeOpaque}
          zIndex={zIndex}
        />
      ) : null}
    </>
  );
};

export default RoutePath;
